import { render, staticRenderFns } from "./SwitchList.vue?vue&type=template&id=6e724132&scoped=true"
import script from "./SwitchList.vue?vue&type=script&lang=js"
export * from "./SwitchList.vue?vue&type=script&lang=js"
import style0 from "./SwitchList.vue?vue&type=style&index=0&id=6e724132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e724132",
  null
  
)

export default component.exports